/**
 * Send an e-mail with a special link that the user can use to overwrite a
 * forgotten password.
 *
 * @module
 */
import {popup} from '@acng/frontend-discovery';
import {MailFormController} from 'nova';

import {post} from '../../core/service/backend.js';
import {getLocalOverlay} from '../../core/service/overlay.js';
import {t} from '../../locale/config/translate.js';

/**
 * @example
 *
 * ```html
 * <!--@ ${auth.login.mail} -->
 * <form>
 *   <input name="email" />
 *   <input type="submit" />
 * </form>
 * ```
 */
class PasswordMail extends MailFormController {
  /**
   * @param {HTMLFormElement} form
   * @param {FormData} data
   */
  async submit(form, data) {
    try {
      await post('user/remind-password', data, form);
      await popup(form).info(await t('userPool.pwForgottenMailSent'));
      form.reset();
      getLocalOverlay(form)?.close();
    } catch (e) {
      // all handled by core/service/backend
    }
  }
}

export {PasswordMail};
